var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 253.08 260.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#e30613;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-171.1 -255.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 595.28,
    height: 841.89
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vektoros katlan logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.27,478.43c-11.06,2.09-36.22,6.13-35-6.07.65-6.43,20.19-3.41,35,6.07m146.52-1.67s16.53,9.1,16.2,8.71c-66.58,36.81-108.32,21.7-136.23.11-.59-.46,20.58-.83,37.67-14.44,3-4.57-14.08-22.11-14.7-22.6-6-3.25,4.42,16.73-33,27.38-57.51-41.73-69.73-11.9-68.52-.28,2.23,21.46,24,25.86,65.73,13.94,52.75,43.91,111.44,24.58,152.09,1.84l2.5,18.77,32.68-43.52Z",
    transform: "translate(-171.1 -255.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334.5,455c7.91-30.36-28-19.09-10.47-45.54-26.74,4-26,22-22.32,33.69,1.86,6-.1,19.08-7.09,18.75-12.94-.6-9.33-21.66-20.64-30.09a134.22,134.22,0,0,0,2.87-32.6c.19-11.31,9-18.68,20.13-22.05,13-3.93,25.89.39,32.79,11.89,0,0,7.38,8.21,10.33,14.49,8.59,18.27,15,31.42-5.6,51.46m35.12-116.61c-.94,21-21,9.21-16.52,27.46,0,0-2.06-3-3.52-5.24-7.59-11.78-21.5-12.1-20.16-36.46-4.25,12-16.64,15.32-21.36,27.36-14.23-.15-16-13.32-14.95-23.24,0,0-13.38,7.1-11.73,22.55.9,8.47-7.26,10.8-12.66,17.1,10.91-22-15.33-7.57-14.63-45-17.78,28-18.27,40.36-9.32,60,3.51,7.69-9.4,13.62-2.1,38.78.24,18.88,9.75,32.1,23.6,47.44,8.31,9.19,13.38,15.12,24.85,19.82s19.38,5.25,31.62,3.31c21.4-3.4,32.27-20.3,45-32.57,17.7-20.3-5.7-47.9,5.39-73.9,6.79-15.91-3.52-47.44-3.52-47.44",
    transform: "translate(-171.1 -255.31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.83,255.31c-14.61,43.21,12.43,69.94,12.43,69.94,22.38-10.88,22.7-20.2,22.7-20.2-37.93-28.91-35.13-49.74-35.13-49.74",
    transform: "translate(-171.1 -255.31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.09,261.68c14.61,43.21-12.43,69.94-12.43,69.94C336.28,320.74,336,311.41,336,311.41c37.92-28.9,35.12-49.73,35.12-49.73",
    transform: "translate(-171.1 -255.31)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTop);
export default __webpack_public_path__ + "static/media/logo-top.ffd4ea74550598b0e4c13d6867be80e3.svg";
export { ForwardRef as ReactComponent };